import Vue from "vue";
import { defineStore } from "pinia";
import Uchi from "@/models/Uchi/uchi";
import axios from "axios";
import apiUchi from "@/helpers/api/apiUchi";
import FileHelper from "@/helpers/utilities/FileHelper";

export const useUchiStore = defineStore("uchiD", {
  state: () => ({
    loading: false,
    error: null,
    uchiState: [],
    sortKey: "sharedWithName",
    setup: {},
    files: [],
    users: [],
    driveId: "",
    itemId: "",
    emailOptions: []
  }),

  actions: {
    async loadUchi() {
      this.loading = true;
      this.error = null;

      try {
        if (this.uchiState.length === 0) {
          return this.reloadUchi();
        }
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async reloadUchi() {
      const [res1, res2] = await Promise.all([apiUchi.get(`/me/shares`), apiUchi.get(`/me/sharedwith/institution`)]);

      this.uchiState;

      const uchis = res1.data.results.map(u => {
        const item = new Uchi(u);

        item.owner = { displayName: null };
        return item;
      });

      const uchis2 = res2.data.results.map(u => new Uchi(u));
      const combined = [...uchis, ...uchis2];
      Vue.set(this, "uchiState", combined);
    },

    async loadSettings() {
      const response = await apiUchi.get(`/me/setup/quickshare`);
      response.data.quickShare.forEach(element => {
        if (element.key === "code_subject") {
          this.setup["code_setup"] = element.value;
        }
        if (element.key === "default_accesscoderequired") {
          this.setup["defaultAccessCode_setup"] = element.value === "true";
        }
        if (element.key === "default_expiredays") {
          this.setup["defaultExpiredays_setup"] = element.value;
        }
        if (element.key === "default_usercanoverride") {
          this.setup["defaultUserCanOverride_setup"] = element.value === "true";
        }
      });
    },

    async searchEmails(searchString) {
      if (!searchString) {
        this.emailOptions = [];
        return;
      }
      try {
        const response = await apiUchi.get(`/users/${searchString}`);

        this.emailOptions = response.data.filter(
          e => e.email && typeof e.email === "string" && e.email.toLowerCase().includes(searchString.toLowerCase())
        );
      } catch {
        /* empty */
      }
    },

    resetSearchEmails() {
      this.emailOptions = [];
    },

    async addUchi(uchi) {
      return await apiUchi.post("/shares", uchi);
    },

    async removeSubject(uchiId) {
      await apiUchi.delete(`/shares/${uchiId}`);
      await this.reloadUchi();
      //this.uchiState = this.uchiState.filter(uId => uId.shareId !== id);
    },

    async removeAShareFile(uchiId, fileId) {
      await apiUchi.delete(`/shares/${uchiId}/files/${fileId}`);
      this.files = this.files.filter(file => file.id !== fileId);
      await this.reloadUchi();
    },

    async updateUchiShare(uchi) {
      await apiUchi.patch(`/shares/${uchi.externalShareId}`, {
        title: uchi.title,
        expiresWhen: uchi.expiresWhen,
        accessCodeRequired: uchi.accessCodeRequired
      });

      await this.reloadUchi();
    },

    async uploadDriveItemToBlobStorage(shareId, fileObject) {
      const binary = await FileHelper.getFileAsBinary(fileObject.file);
      const addFileResult = await apiUchi.post(`/shares/${shareId}/files`, { filename: fileObject.name });
      const uploadFileResult = await axios.put(addFileResult.data.uploadUrl, binary, {
        headers: {
          "Content-Type": "application/octet-stream",
          "Content-Length": binary.length,
          "x-ms-blob-type": "BlockBlob"
        }
      });
      return uploadFileResult.data;
    },

    async addUserToUchi(identifier, userData) {
      const response = await apiUchi.post(`/shares/${identifier}/users`, userData);
      await this.reloadUchi();
      return response.data;
    },

    async removeUserFromUchi(identifier, userIdentifier) {
      await apiUchi.delete(`/shares/${identifier}/users/${userIdentifier}`);

      await this.reloadUchi();
    }
  },

  getters: {
    uchis: state => {
      return state.uchiState;
    },
    uchi: state => externalShareId => state.uchiState.find(u => u.externalShareId == externalShareId),
    getDriveItemId: state => (driveId, itemId) => state.uchiState.find(u => u.driveId == driveId && u.itemId == itemId),
    getDeleteFromFolderName: state => (driveId, itemId) =>
      state.uchiState.find(u => u.driveId == driveId && u.itemId == itemId)
  }
});
